<section class="cst_body">
    <!-- <div class="nav" >
        <ul>
            <li *ngIf="isSampleSubmissionMemo && selectedItems.length > 0">
                <button type="submit" class="paymentispbtn" [ngClass]="{'active' : isRefundbtn}" (click)="sampleSubmission()">Submit Samples</button>
            </li>
           
        </ul>
    </div> -->
  <div class="container-fluid search_flt_box_main">
    <!-- need to write -->
    <form [formGroup]="searchForm" (ngSubmit)="search(searchForm)">
      <div class="search_flt_box">
        <div class="row">
        <div class="col-md-3" >
            <div class="form-group">
              <label for="formGroupExampleInput">Client Name</label>
              <ng-select [items]="tenantsList" [multiple]="true" [closeOnSelect]="false" [clearable]="true"
                (clear)="resetTeantFilters();" bindLabel="tenantName" bindValue="tenantCode" placeholder="Select Client"
                (click)="onTenantSelect()" formControlName="selectedTenant">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice:0:2">
                    <span class="ng-value-label"> {{item.tenantName}}</span>
                    <span class="ng-value-icon right" (click)="onTenantdeSelect(item);clear(item);"
                      aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 2">
                    <span class="ng-value-label">{{items.length - 2}} more...</span>
                  </div>
                </ng-template>
              </ng-select>
 
            </div>
          </div>
          <div class="col-md-3" *ngIf="searchForm.controls['selectedTenant'].value">
            <div class="form-group">
              <label for="formGroupExampleInput">Client Organization</label>
              <ng-select [items]="organizationsOfTenants" [multiple]="true" [closeOnSelect]="false" bindLabel="organizationName"
                bindValue="organizationCode" placeholder="Select Organization" (click)="onOrgSelect()"
                formControlName="selectedOrg">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice:0:2">
                    <span class="ng-value-label"> {{item.organizationName}}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 2">
                    <span class="ng-value-label">{{items.length - 2}} more...</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
                  <label>Select Daterange:</label>
                  <div class="input-group">
                    <input class="form-control" #drp="bsDaterangepicker" bsDaterangepicker 
                    [bsValue]="bsRangeValue"
                    (bsValueChange)="onValueChange($event)" >
                    <div class="input-group-append">
                      <button class="btn btn-success calcBtn" (click)="drp.toggle()" [attr.aria-expanded]="drp.isOpen" type="button"><i
                        class="fa fa-calendar" aria-hidden="true"></i></button>
                    </div>
                  </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>Status</label>
              <select id="inputState" class="form-control col-form-label-sm" formControlName="status" [(ngModel)]="selectedStatusValue">

               
                <option [ngValue]="null" disabled>Select</option>
                <option *ngFor="let data of orderStatusList" [ngValue]="data.value">{{data.name}}</option>
              </select>
            </div>
          </div>
        </div>          
         
            <div class="row">
               <!--  <div class="col-2">
                <div class="form-group">
                  <label>Status</label>
                  <select id="inputState" class="form-control col-form-label-sm" formControlName="status" [(ngModel)]="selectedStatusValue">

                   
                    <option [ngValue]="null" disabled>Select</option>
                    <option *ngFor="let data of orderStatusList" [ngValue]="data.value">{{data.name}}</option>
                  </select>
                </div>
              </div> -->
          <div class="col-md-2">
                <div class="form-group">
                  <label for="formGroupExampleInput">Search By Business</label>
                   <select id="inputState" class="form-control col-form-label-sm leftSearchBox" formControlName="businessId">
                    <option [ngValue]="null" disabled>Select</option>
                    <option *ngFor="let businessoption of dynamicBusiness" [value]="businessoption.ID" >{{ businessoption.displayName }}</option>
                  </select> 
                </div>
          </div>          <div class="col-md-2">
            <div class="form-group">
              <label for="formGroupExampleInput">Select Orders Type</label>
               <select id="inputState" class="form-control col-form-label-sm leftSearchBox" formControlName="ordersType">
                <option value="">All</option>
                <option  value="packageChildsOnly" >Child Orders</option>
                <!-- <option  value="careparents" >Parent Orders</option> -->
              </select> 
            </div>
      </div>
			    <div class="col-md-4 d-flex">
            <div class="form-group width40p">
              <label for="formGroupExampleInput">Search By</label>
              <select id="inputState" class="form-control col-form-label-sm" formControlName="searchBy">
                <option [ngValue]="null" disabled>Select</option>
                <option>MRN</option>
                <option>Order ID</option>
                <option>Order Did</option>
              </select>
            </div>
              <div class="form-group width60p">
              <label for="formGroupExampleInput">Enter Value</label>
              <input type="text" class="form-control col-form-label-sm" formControlName="searchByValue"
                placeholder="Enter Value">
            </div>
          </div>

              
              <div class="col-md-2 padLftRht6">
                <button type="submit" class="btn green_btn">Search</button>&nbsp;
                <button  class="btn green_btn" (click)="clear()">Clear</button>
              </div>

                            
       

        </div>
      </div>
      <!-- need to close -->
    </form>

  </div>
  <div class="container-fluid" role="main" >
    <div class="table_main tableShadow">
      <table class="table table-striped table-responsive" *ngIf="orderDetailsRes?.length>0">
        <thead>
          <tr class="tbl_name">
            <th *ngIf="isSampleSubmissionMemo"> <input type="checkbox" name="allorders_select" (change)="selectAll()" [checked]="selectedItems.length === orderDetailsRes.length && orderDetailsRes.length >0"> Select All</th>
            <th>MRN</th>
            <th>Customer Name</th>
            <th>Order DID</th>
            <th>Service Type</th>
            <th>Vendor Name</th>
            <th>Order Created Date</th>
            <th>Scheduled Date</th>
            <th>Order Status</th>
            <th>Payment Status</th>
            <th>Actions &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let orderDetailsObj of orderDetailsRes;let i = index">
         
            <td *ngIf="isSampleSubmissionMemo"><input type='checkbox' calss = 'myCheckbox' (change)="toggleSelection(orderDetailsObj)"  [checked]="selectedItems.includes(orderDetailsObj)"></td>
            <td>{{orderDetailsObj.order.patientinfo.mrn}}  <p style="color: blue">{{orderDetailsObj.order.patientinfo.corporatename}}</p></td>
            <td>{{orderDetailsObj.order.patientinfo.name}}</td>
            <td>{{orderDetailsObj.order.order_status.order_did}}</td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '3'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Pathology<span *ngIf="orderDetailsObj.order.business.isUCDOrder !=undefined && orderDetailsObj.order.business.isUCDOrder ==1 ">-UCD</span><br/>
            <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '4'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Radiology<span *ngIf="orderDetailsObj.order.business.isUCDOrder !=undefined && orderDetailsObj.order.business.isUCDOrder ==1">-UCD</span><br/>
            <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '1'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Doctor Consultation
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td> <!--opd_c-->
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '2'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Medicines<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '5'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Care at Home<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '6'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Nursing<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '7'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Physiotherapy<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '8'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Bedside Attendant<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '9'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Speciality<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '10'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Doctor<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '11'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Medical Equipment Buying & Rental<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '12'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Emotional Wellbeing Psychiatry & Psychology<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '13'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Second Opinion<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '14'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              MyWellness<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '15'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Family Doctor<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '16'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              BloodConnect<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '19'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Diagnostics Others<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '100'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Package<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '20'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Ophthalmology<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>
            <td *ngIf="orderDetailsObj.order.patientinfo.service_type == '21'">
              <span *ngIf="orderDetailsObj.order.business.pc_order_id">Package</span><br/>
              Dental<br/>
              <span *ngIf="orderDetailsObj.mode_of_service == 1">Home</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 2">Center</span>
              <span *ngIf="orderDetailsObj.mode_of_service == 3">platform</span>
            </td>

            <td>
              <app-diagnostic-center-address [providerInfoObj]="orderDetailsObj.order"></app-diagnostic-center-address>
            </td>
            <td>{{orderDetailsObj.order.order_status.created_date | date:'dd/MM/yyyy hh:mm a'}}</td>
            <td>{{orderDetailsObj.order.patientinfo.scheduled_date | date:'dd/MM/yyyy hh:mm a':'UTC'}}</td>
            <td>{{orderDetailsObj.data.Nomenclature}}</td>
            <td *ngIf="orderDetailsObj.payment_info.payable_amount<=0">Prepaid</td>
            <td *ngIf="orderDetailsObj.payment_info.payable_amount>0">Pending for Payment</td>
            
            <td class="view_btn" >
              <img class="exitImg" src="./assets/img/eye.png"
                (click)="getOrderById(orderDetailsObj.order.patientinfo.order_id,'orders')" ngbTooltip="View Details"
                *ngIf="!isPrintDocumentBtn && (orderDetailsObj.order.patientinfo.corporatetype != 'chopd' && orderDetailsObj.order.patientinfo.corporatetype != 'SVAAS')">&nbsp;
              <img class="exitImg" src="./assets/img/eye.png"
                (click)="getOrderById(orderDetailsObj.order.patientinfo.order_id,'opd')" ngbTooltip="View OPD Details"
                *ngIf="!isPrintDocumentBtn && (orderDetailsObj.order.patientinfo.corporatetype == 'chopd' || orderDetailsObj.order.patientinfo.corporatetype == 'SVAAS')">&nbsp;
              <img class="exitImg" src="./assets/img/info.png"
                (click)="opentrackOrderModal(orderDetailsObj.order.patientinfo.order_id)" ngbTooltip="Track History"
                *ngIf="isTrack && !isPrintDocumentBtn"/>
              <img class="exitImg" src="./assets/img/download.png"
                (click)="invoiceDownload(orderDetailsObj.order.patientinfo.order_id)" [disabled]="fileDownloadDisable"
                ngbTooltip="Download" *ngIf="orderDetailsObj.tenantCode === '1000001' && isPendingBtn && orderDetailsObj.order.patientinfo.service_type == '1'">

              <img class="exitImg" src="./assets/img/download.png" (click)="openPrintDocumentModal(orderDetailsObj)"
                [disabled]="fileDownloadDisable" ngbTooltip="Download" *ngIf="orderDetailsObj.order.patientinfo.service_type != '3' && isPrintDocumentBtn">
              <img class="exitImg" src="./assets/img/download.png" (click)="downloadSampleCollectionMemo(orderDetailsObj.order.patientinfo.order_id)" ngbTooltip="Download" *ngIf="orderDetailsObj.order.patientinfo.service_type != '3' && isSampleCollectionMemo">
              <img class="exitImg" src="./assets/img/download.png" (click)="downloadSampleCollectionMemo(orderDetailsObj.order.patientinfo.order_id)" ngbTooltip="Download" *ngIf="orderDetailsObj.order.patientinfo.service_type != '3' && isSampleSubmissionMemo">
              <img class="exitImg" src="./assets/img/download.png" (click)="downloadSampleCollectionMemo(orderDetailsObj.order.patientinfo.order_id)" ngbTooltip="TRF Download" *ngIf="orderDetailsObj.order.patientinfo.service_type == '3'">
              <img class="exitImg" src="./assets/img/list.png" (click)="gotoChildOrders(orderDetailsObj)" ngbTooltip="Child Orders List" *ngIf="orderDetailsObj?.order?.business?.is_parent ==1 &&  (orderDetailsObj.order.patientinfo.service_type == '5' || orderDetailsObj.order.patientinfo.service_type == '6' || orderDetailsObj.order.patientinfo.service_type == '7' || orderDetailsObj.order.patientinfo.service_type == '8' || orderDetailsObj.order.patientinfo.service_type == '100') "  >
              <img class="exitImg" src="./assets/img/list.png" (click)="gotoChildOrders(orderDetailsObj)" ngbTooltip="Package Orders List" *ngIf=" orderDetailsObj.order.business.pc_order_id != undefined &&  orderDetailsObj.order.business.pc_order_id !=='' "  >
              <img class="exitImg" src="./assets/img/invoice.png" (click)="downloadInvoiceD(orderDetailsObj.order.patientinfo.order_id)" ngbTooltip="Invoice Download">
            </td>
          </tr>

        </tbody>
      </table>

    </div>
    <div *ngIf="isOrderListDataExist" class="noRecord"><b>No Records Found</b></div>
    <div class="col-12 tableBottom" *ngIf="orderDetailsRes?.length">
      <div class="totalRecords">
        Total Orders <span class="fnt-medium">({{totalRecords}})</span>
      </div>
     <div>
      <ngb-pagination [collectionSize]="datacount" [(page)]="page" [pageSize]="pageSize" [maxSize]="5"
      [boundaryLinks]="true" class=" customPagination" (pageChange)="pageChange(page)">
    </ngb-pagination>
     </div> 
    </div>

  </div>
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
  </ngx-spinner>

  
</section>